
// src/widgets/UserStatsWidget.tsx
import { IUser } from "../IUser";

/**
 * A widget to display some basic user statistics.
 * This will be a placeholder for now.
 */
export function UserStatsWidget(data?: IUser): HTMLElement {
    const content = document.createElement('div');
    content.className = 'widget-content';

    // Placeholder data, to be replaced with real data later
    const stats = data || {
        userName: 'Player 1',
        wins: 10,
        losses: 5,
        avgPPR: 2.5
    };

    content.innerHTML = `
        <div><strong>Wins:</strong> ${stats.wins}</div>
        <div><strong>Losses:</strong> ${stats.losses}</div>
        <div><strong>Avg PPR:</strong> ${stats.avgPPR?.toFixed(2)}</div>
    `;

    return content;
}
